import { mapGetters, mapActions } from "vuex";

import StarRating from "vue-star-rating";

import progressRing from "@/components/atoms/circle-progress/index.vue";
import BaseModal from "@/components/modals/BaseModal";
import PackageAccessNotice from "@/components/features/package-access-notice/index.vue";

import { $http } from "@/utils/https";

export default {
	name		: "courses-item",
	props		: {
		item: {
			type	: Object,
			default	: {},
		},
		user: {
			type	: Object,
			default	: {},
		},
	},
	components	: {
		BaseModal,
		"circle-progress": progressRing,
		StarRating,
		"package-access-notice": PackageAccessNotice,
	},
	data() {
		return {
			digitsVisible	: false,
			percent			: 0,
			radius			: 15,
			showProgressTesterModal	: false,
			progressTesterMode		: "complete",
			progressTesterPercent	: 0,
			isProgressTesterSubmitting	: false,
		};
	},
	computed	: {
		...mapGetters({
			coursesListStatus: "courses/coursesListStatus",
		}),
		totalTimeModule() {
			return this.calculationTimeModule(this.item.course.data.duration);
		},
		progress() {
			return this.materialsProgressPercent
		},
		materialsProgressPercent() {
			const it = this.item
			
			if (!it || !it.course || !it.course.data) {
				return 0
			}
			
			const total =
				it.course.data.materialsCount != null
					? it.course.data.materialsCount
					: it.course.data.materials_count
			
			const done =
				it.completedMaterials != null
					? it.completedMaterials
					: it.completed_materials
			
			const t = Number(total)
			const d = Number(done)
			
			if (!Number.isFinite(t) || t <= 0 || !Number.isFinite(d) || d < 0) {
				return 0
			}
			
			return Math.min(100, Math.round((100 * d) / t))
		},
		resolvedUserCourseId() {
			const it = this.item
			
			if (!it) {
				return null
			}
			
			if (it.id != null) {
				return it.id
			}
			
			if (it.user_course_id != null) {
				return it.user_course_id
			}
			
			return null
		},
		resolvedCourseId() {
			const it = this.item
			
			if (!it) {
				return null
			}
			
			if (it.courseId != null) {
				return it.courseId
			}
			
			if (it.course_id != null) {
				return it.course_id
			}
			
			if (it.course && it.course.data && it.course.data.id != null) {
				return it.course.data.id
			}
			
			return null
		},
		/**
		 * Мінімальний відсоток для set-progress (як Math.round(100 * completed / total)).
		 * Не можна опустити слайдер нижче поточного прогресу.
		 */
		progressTesterMinPercent() {
			return this.materialsProgressPercent
		},
		completedMaterialsLabel() {
			const it = this.item
			
			if (!it) {
				return "0"
			}
			
			if (it.completedMaterials != null) {
				return String(it.completedMaterials)
			}
			
			if (it.completed_materials != null) {
				return String(it.completed_materials)
			}
			
			return "0"
		},
		materialsCountLabel() {
			const it = this.item
			
			if (!it || !it.course || !it.course.data) {
				return "0"
			}
			
			const c = it.course.data
			
			if (c.materialsCount != null) {
				return String(c.materialsCount)
			}
			
			if (c.materials_count != null) {
				return String(c.materials_count)
			}
			
			return "0"
		},
	},
	watch: {
		progressTesterMode(val) {
			if (val !== "set-progress") {
				return
			}
			
			const lo = this.progressTesterMinPercent
			const cur = Number(this.progressTesterPercent)
			
			this.progressTesterPercent = Math.min(
				100,
				Math.max(lo, Number.isFinite(cur) ? cur : lo)
			)
		},
	},
	created() {},
	methods		: {
		...mapActions({
			setLessonFavourite		: "coursesLesson/SET_LESSON_FAVOURITE",
			setLessonUnfavourite	: "coursesLesson/SET_LESSON_UNFAVOURITE",
			getList					: "courses/GET_LIST",
		}),
		calculationTimeModule(duration) {
			const hours = Math.floor(duration / 60);
			const minutes = duration % 60;
			
			return `${hours} ${this.$t("smHour")}  ${
				minutes < 10 ? "0" + minutes : minutes
			}  ${this.$t("smMinutes")}`;
		},
		declensionWord(count) {
			let titles = [
				this.$t("lessonWord1"),
				this.$t("lessonWord2"),
				this.$t("lessonWord3"),
			];
			
			let cases = [2, 0, 1, 1, 1, 2];
			
			return titles[
				count % 100 > 4 && count % 100 < 20
					? 2
					: cases[count % 10 < 5 ? count % 10 : 5]
			];
		},
		getLesson() {},
		resolveAbFormPackageId(item) {
			if (!item) return null
			
			// my/courses: атрибут package_id → після camelcaseObjectDeep у https — packageId
			if (item.packageId != null) {
				return item.packageId
			}
			
			if (item.package_id != null) {
				return item.package_id
			}
			
			if (item.package && item.package.data && item.package.data.id != null) {
				return item.package.data.id
			}
			
			const courseData = item.course && item.course.data
			
			if (courseData && courseData.package && courseData.package.data && courseData.package.data.id != null) {
				return courseData.package.data.id
			}
			
			if (courseData && courseData.packageId != null) {
				return courseData.packageId
			}
			
			if (item.userCourse && item.userCourse.data) {
				const uc = item.userCourse.data
				
				if (uc.package && uc.package.data && uc.package.data.id != null) {
					return uc.package.data.id
				}
				
				if (uc.packageId != null) return uc.packageId
			}
			
			return null
		},
		getCourseMaterialRoute(item) {
			if (!item.currentMaterial || !item.currentMaterial.data) {
				return null
			}
			
			const type = item.currentMaterial.data.material
			const courseSlug = item.course.data.slug
			const moduleSlug = item.currentMaterial.data.module.data.slug
			const matSlug = item.currentMaterial.data.slug
			
			if (type === "lesson") {
				return {
					name	: "courses-lesson-detail",
					params	: {
						item		: courseSlug,
						moduleSlug,
						lessonSlug	: matSlug,
					},
				}
			}
			
			if (type === "home_work") {
				return {
					name	: "home-work-rules",
					params	: {
						item		: courseSlug,
						moduleSlug,
						testId		: matSlug,
					},
				}
			}
			
			if (type === "graduate_work") {
				return {
					name	: "graduate-work-rules",
					params	: {
						item		: courseSlug,
						moduleSlug,
						testId		: matSlug,
					},
				}
			}
			
			return null
		},
		getChangeBtnStartRoute(item) {
			const slug = item.course.data.slug
			const fallback = {
				name	: "courses-main",
				params	: { item: slug },
			}
			
			switch (item.status) {
				case "new":
					if (item.currentMaterial && item.currentMaterial.data && item.currentMaterial.data.length) {
						return this.getCourseMaterialRoute(item) || fallback
					}
					
					return fallback
				case "processing":
					if (item.currentMaterial) {
						return this.getCourseMaterialRoute(item) || fallback
					}
					
					return fallback
				case "completed":
					return fallback
				default:
					return fallback
			}
		},
		buildAbModalPayload(nextRoute) {
			const course = this.item && this.item.course && this.item.course.data
			
			if (!course || !course.slug) {
				return null
			}
			
			const packageId = this.resolveAbFormPackageId(this.item)
			
			const fallback = {
				name	: "courses-main",
				params	: { item: course.slug },
			}
			
			const pointAClosedCount = Number(
				this.item.pointAClosedCount != null
					? this.item.pointAClosedCount
					: (this.item.point_a_closed_count != null
						? this.item.point_a_closed_count
						: 0)
			) || 0
			
			return {
				courseSlug	: course.slug,
				...(packageId != null ? { packageId } : {}),
				courseId	: course.id,
				nextRoute	: nextRoute && nextRoute.name ? nextRoute : fallback,
				isPointAFilled	: !!(
					this.item.isPointAFilled != null
						? this.item.isPointAFilled
						: this.item.is_point_a_filled
				),
				isPointBFilled	: !!(
					this.item.isPointBFilled != null
						? this.item.isPointBFilled
						: this.item.is_point_b_filled
				),
				materialsProgressPercent	: this.materialsProgressPercent,
				pointAClosedCount,
			}
		},
		emitOpenPointA(nextRoute) {
			const payload = this.buildAbModalPayload(nextRoute)
			
			if (!payload) {
				return
			}
			
			this.$emit("open-point-a", payload)
		},
		emitOpenPointB(nextRoute) {
			const payload = this.buildAbModalPayload(nextRoute)
			
			if (!payload) {
				return
			}
			
			this.$emit("open-point-b", payload)
		},
		openAbModalFlow(nextRoute) {
			const course = this.item && this.item.course && this.item.course.data
			
			if (!course || !course.slug) {
				return
			}
			
			const pointAFilled = !!(
				this.item.isPointAFilled != null
					? this.item.isPointAFilled
					: this.item.is_point_a_filled
			)
			
			const pointBFilled = !!(
				this.item.isPointBFilled != null
					? this.item.isPointBFilled
					: this.item.is_point_b_filled
			)
			
			if (!pointAFilled) {
				this.emitOpenPointA(nextRoute)
				
				return
			}
			
			if (pointAFilled && !pointBFilled && this.materialsProgressPercent >= 80) {
				this.emitOpenPointB(nextRoute)
				
				return
			}
			
			this.$emit("course-ab-navigate", this.buildAbModalPayload(nextRoute))
		},
		openPointAModal() {
			this.openAbModalFlow(null)
		},
		openPointAModalForButton() {
			this.openAbModalFlow(this.getChangeBtnStartRoute(this.item))
		},
		async onClickFavorite(item) {
			const storedPin = item.pin;
			item.pin = !item.pin;
			
			try {
				if (item.pin) {
					try {
						await this.setLessonFavourite({
							slug: item.course.data.slug,
						});
					} catch (err) {
						item.pin = storedPin;
						console.log("error");
						throw err;
					}
				}
				
				if (!item.pin) {
					try {
						await this.setLessonUnfavourite({
							slug: item.course.data.slug,
						});
					} catch (err) {
						item.pin = storedPin;
						console.log("error");
						throw err;
					}
				}
				
				await this.getList({ isResetList: false, isSkip: true });
			} catch (error) {
				console.error("error[pin]", error);
			}
		},
		checkTest(){
			if(!this.user.isTester){
				return false;
			}
			
			if(this.item.completedMaterials == this.item.course.data.materialsCount){
				return false;
			}
			
			return true;
		},
		progressModal() {
			const lo = this.materialsProgressPercent
			
			this.progressTesterMode = "complete"
			this.progressTesterPercent = lo
			this.showProgressTesterModal = true
		},
		closeProgressTesterModal() {
			if (this.isProgressTesterSubmitting) {
				return
			}
			
			this.showProgressTesterModal = false
		},
		async submitProgressTester() {
			if (this.isProgressTesterSubmitting) {
				return
			}
			
			const userCourseId = this.resolvedUserCourseId
			const courseId = this.resolvedCourseId
			
			if (userCourseId == null && courseId == null) {
				if (this.$toasted) {
					this.$toasted.error("Не вдалося визначити user_course_id або course_id.")
				}
				
				return
			}
			
			let progressValue = null
			
			if (this.progressTesterMode === "set-progress") {
				const lo = this.materialsProgressPercent
				const p = Number(this.progressTesterPercent)
				
				if (!Number.isFinite(p) || p < lo || p > 100) {
					if (this.$toasted) {
						this.$toasted.error(
							`Прогрес має бути від ${lo} до 100% (поточний мінімум за матеріалами).`
						)
					}
					
					return
				}
				
				progressValue = Math.round(p)
			}
			
			const base = process.env.VUE_APP_ROOT_COURSE
			const body = {}
			
			if (userCourseId != null) {
				body.user_course_id = userCourseId
			} else {
				body.course_id = courseId
			}
			
			this.isProgressTesterSubmitting = true
			
			try {
				if (this.progressTesterMode === "set-progress") {
					body.progress = progressValue
					await $http.post(`${base}course-progress-test/set-progress`, body)
				} else {
					await $http.post(`${base}course-progress-test/complete`, body)
				}
				
				if (this.$toasted) {
					this.$toasted.success("Прогрес оновлено.")
				}
				
				this.showProgressTesterModal = false
				await this.getList({ isResetList: false, isSkip: true })
			} catch (e) {
				console.error("course-progress-test", e)
				
				const hasValidation =
					e.response &&
					e.response.data &&
					e.response.data.validation &&
					Object.keys(e.response.data.validation).length
				
				if (this.$toasted && !hasValidation) {
					this.$toasted.error("Не вдалося оновити прогрес.")
				}
			} finally {
				this.isProgressTesterSubmitting = false
			}
		},
	}
};
